import React from "react";
import KeyPositionRequest from "../../features/KeyPositionRequest/KeyPositionRequest";
const KeyPositionRequestPage = () => {
  return (
    <div className="page-container">
      <KeyPositionRequest/>
    </div>
  );
};
export default KeyPositionRequestPage;
